<template>
  <div class="polarity-page">
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12" class="text-center">
          <h1 class="mb-4">
            Contact Control
            <HelpCenterButton classes="me-2" content-key="ab_polarity" />
          </h1>
          <p class="polarity-alert">
            Contact Control allows an admin to keep pairs of students from being
            on an active hallpass at the same time.
          </p>
        </CCol>
      </CRow>
      <CRow class="mt-4">
        <CCol md="6" class="text-center mb-4 mb-md-0">
          <div class="polarity-form-container">
            <div
              class="d-flex align-items-center justify-content-center iconed-title pt-2 pb-1 pt-sm-4 pb-sm-3"
            >
              <h2>Choose Students</h2>
              <span
                class="icon ms-2"
                @click="isCreateFormVisible = !isCreateFormVisible"
              >
                <i
                  :class="
                    !isCreateFormVisible
                      ? 'flaticon-double-chevron down'
                      : 'flaticon-double-chevron up'
                  "
                />
              </span>
            </div>
            <div v-show="isCreateFormVisible" class="px-4 py-4">
              <CreateABPolarityForm
                :students="students"
                is-in-view="true"
                @create-polarity="refreshDataTable"
              />
            </div>
          </div>
        </CCol>
        <CCol md="6" class="text-center">
          <div class="polarity-form-container">
            <div
              class="d-flex align-items-center justify-content-center iconed-title pt-2 pb-1 pt-sm-4 pb-sm-3"
            >
              <h2>Edit Message</h2>
              <span
                class="icon ms-2"
                @click="isMessageFormVisible = !isMessageFormVisible"
              >
                <i
                  :class="
                    !isMessageFormVisible
                      ? 'flaticon-double-chevron down'
                      : 'flaticon-double-chevron up'
                  "
                />
              </span>
            </div>
            <div v-show="isMessageFormVisible" class="px-4 py-4 pb-3">
              <p class="text-start mt-0 px-3">
                Message all Polarity Students will see when they try to create a
                pass while their polarity person is already out on a pass.
              </p>
              <PolarityMessageForm />
            </div>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol md="12">
          <PolaritiesDataTable ref="PolaritiesDataTable" />
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import CreateABPolarityForm from "@/components/Forms/CreateABPolarityForm"
import PolarityMessageForm from "@/components/Forms/PolarityMessageForm"
import PolaritiesDataTable from "@/components/DataTables/PolaritiesDataTable"
import HelpCenterButton from "@/components/HelpCenterButton"
import { mapGetters } from "vuex"

export default {
  name: "ABPolarity",
  components: {
    CreateABPolarityForm,
    PolarityMessageForm,
    PolaritiesDataTable,
    HelpCenterButton
  },
  data() {
    return {
      isCreateFormVisible: false,
      isMessageFormVisible: false
    }
  },
  computed: {
    ...mapGetters({
      students: "users/formListStudents"
    })
  },
  methods: {
    refreshDataTable() {
      this.$refs.PolaritiesDataTable.refreshDataTable()
    }
  }
}
</script>
